<template>
  <div>
    <div
      class="overflow-hidden text-pretty transition-[max-height] duration-200 ease-in-out"
      :style="wrapper_style"
    >
      <div
        ref="content_inner"
        class="content"
        data-test="text-content"
        :style="clamp_style"
        v-html="html_text"
      />
    </div>
    <button
      v-if="is_overflowing"
      type="button"
      class="mt-1 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:underline"
      :aria-expanded="is_expanded"
      @click.stop="toggleExpand"
    >
      {{ $t(is_expanded ? 'editor_ziggu.actions.showLess' : 'editor_ziggu.actions.showMore') }}
      <FontAwesomeIcon
        :icon="['far', 'chevron-down']"
        class="transition-transform duration-200"
        :class="{ 'rotate-180': is_expanded }"
      />
    </button>
  </div>
</template>

<script setup>
import { computed, nextTick, onMounted, ref } from 'vue';

const props = defineProps({
  html_text: { type: String, required: true },
  lines: { type: Number, default: 4 },
});

const content_inner = ref(null);
const is_expanded = ref(false);
const is_overflowing = ref(false);
const collapsed_height = ref(0);
const expanded_height = ref(0);

const clamp_style = computed(() => {
  if (is_expanded.value) return {};
  return {
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: String(props.lines),
    overflow: 'hidden',
  };
});

const wrapper_style = computed(() => {
  if (!is_overflowing.value) return {};
  return {
    maxHeight: is_expanded.value ? `${expanded_height.value}px` : `${collapsed_height.value}px`,
  };
});

onMounted(async () => {
  await nextTick();
  if (!content_inner.value) return;
  collapsed_height.value = content_inner.value.clientHeight;
  expanded_height.value = content_inner.value.scrollHeight;
  is_overflowing.value = expanded_height.value > collapsed_height.value + 1;
});

function toggleExpand() {
  if (!is_expanded.value) {
    expanded_height.value = content_inner.value.scrollHeight;
  }
  is_expanded.value = !is_expanded.value;
}
</script>
